import styled from 'styled-components';
import { HEADER_HEIGHT, HEADER_TABS_HEIGHT } from '../../common/global'
import { LABEL_TITLE, LIST, LABEL } from 'common/base';
import { SIZE } from 'common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const TabsContainer = styled.div`
    display: flex;
    position:relative;
    height: ${HEADER_TABS_HEIGHT};
    justify-content: flex-start;
    padding-left: ${SIZE.ONE}px;
    flex:  0 0 auto;
`

export const TabsList = styled(LIST)`
    flex-flow: row;
`
export interface TabListItemProps {
    disabled: boolean
}

export const TabListItem = styled.li`
    display:flex;
    padding: 0 ${SIZE.TWO}px;
    justify-content: flex-start;
    flex-flow: column;
    &:hover {
        cursor: ${(props: TabListItemProps) => props.disabled ? 'auto' : 'pointer'};
    }

`

export interface TabItemProps {
    isSelected: boolean
    disabled: boolean
}
export const TabItemText = styled(LABEL)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 20px;
    line-height: normal;
    letter-spacing: normal;    
    color: ${(props: TabItemProps) => props.disabled ? "#b1b2b5" : props.isSelected ? "#f4664e" : "#707070"};    
    padding-left:${SIZE.THREE}px;
    padding-right:${SIZE.THREE}px;
 
`
export interface TabItemUnderlineProps {
    moveTo: number
    width: number
}
export const TabItemUnderline = styled.div`
    height: 2px;
    background: #f4664e;
    position: absolute;
    bottom: 8px;
    left: ${(props: TabItemUnderlineProps) => props.moveTo}px;
    width: ${(props: TabItemUnderlineProps) => props.width}px;
    transition: all 0.3s;
    animation-timing-function: ease;

`

export const TabGeneralUnderline = styled.div`
    height: 1px;
    background: #707070;
    opacity: 0.4;
    position: absolute;
    bottom: 10px;
    left: ${SIZE.TWO + SIZE.ONE}px;
    width: calc(100% - ${SIZE.FOUR}px);
`
